export default {
  sm: `
  Beyond the records of 
  the past and present, 
  to become the wisdom 
  for the future
  `,
  md: `
  Beyond the records of 
  the past and present, 
  to become the wisdom 
  for the future
  `,
  xxl: `
  Beyond the records of the 
  past and present, 
  to become the wisdom for 
  the future
  `,
};
